type PushInp = {
  event: string
  ecommerce?: Record<string, unknown>
  [key: string]: unknown
}

export type AdsEvent = Partial<{
  cart: { updates: gen.InputBuyerCartAdd[]; prev: gen.BuyerCartItemFragment[]; target: CartItem[]; res: gen.BuyerCartItemFragment[] }
  begin_checkout: { checkout: gen.CheckoutDraftValuesFragment }
  purchase: { payment: gen.PaymentProviderDocFragment | None; orders: gen.BuyerPaymentMutation['buyerPayment']['order'] }
  add_payment_info: { type: gen.PaymentType; checkout: gen.CheckoutDraftValuesFragment; log: string }
  add_shipping_info: { checkout: gen.CheckoutDraftValuesFragment }
}>

export const useAdsState = (): globalThis.Ref<{ event: AdsEvent; at: number }[]> => useState('AdsEvent', () => shallowRef([]))

type SyncAsync<T> = T | Promise<T>

export function useAds(): {
  push: (cb: () => AdsEvent | None) => void
  save: (cb: () => SyncAsync<PushInp | PushInp[] | None>) => void
} {
  const fast = useFast()
  // const analytics = useAnalytics()
  const data = useAdsState()
  return {
    push(cb) {
      try {
        const event = cb()
        if (event) data.value = [...data.value, { event, at: new Date().getTime() }]
      } catch (err) {
        console.error('[use ads]', err)
      }
    },
    save(cb) {
      try {
        if (import.meta.client) {
          const send = async () => {
            const values = helpers.arrify(await cb?.())
            if (values.length) {
              if (fast.value) console.log('[ads.save.dev]', ...values)
              else {
                // analytics.track(() => ({ action: 'Event', eventJson: JSON.stringify({ name: '[ads.save]', values }) }))
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ;(window as any).dataLayer?.push?.(...values)
              }
            }
          }
          send().catch((err) => {
            console.error('[ads.save.promise.err]', err)
          })
        }
      } catch (err) {
        console.error('[ads.save.err]', err)
      }
    },
  }
}

export function useAdsPush(cb: () => PushInp | PushInp[] | None, options?: { once?: boolean }): void {
  const ads = useAds()
  let stopGlobal = false
  const timer = useTimeout()

  const unwatch = watch(
    () => cb(),
    (_, __, cleanupWatcher) => {
      timer.set(() => {
        if (stopGlobal) return
        let stopLocal = false
        const stop = (globalStop: boolean) => {
          stopLocal = true
          if (globalStop) {
            stopGlobal = true
            nextTick(() => unwatch())
          }
        }

        cleanupWatcher(() => stop(false))

        ads.save(() => {
          const res = stopLocal || stopGlobal ? undefined : cb()
          if (options?.once && res) stop(true)
          return res
        })
      }, 200)
    },
    { immediate: true }
  )
}
